import React, { useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useTranslation } from "i18n";

const STEP_KEYS = [
  "cvEvaluation",
  "videoCall",
  "practicalTask",
  "interview",
  "jobOffer",
];

const STEP_IMAGES = {
  cvEvaluation: require("assets/images/resume.jpeg"),
  videoCall: require("assets/images/video.jpeg"),
  practicalTask: require("assets/images/task.webp"),
  interview: require("assets/images/offer.webp"),
  jobOffer: require("assets/images/interview.webp"),
};

function HowWeHire() {
  const { t } = useTranslation();

  const jobProcess = useMemo(
    () =>
      STEP_KEYS.map((key) => ({
        key,
        title: t(`howWeHire.steps.${key}.title`),
        description: t(`howWeHire.steps.${key}.description`),
        img: STEP_IMAGES[key],
      })),
    [t],
  );

  useEffect(() => {
    const svg = window.document.querySelector("#svgPath");
    if (!svg) return undefined;

    const length = svg.getTotalLength();
    svg.style.strokeDasharray = length;
    svg.style.strokeDashoffset = length;

    const handleScroll = () => {
      const path = window.document.querySelector("#svgPath");
      if (!path) return;

      const pathLength = path.getTotalLength();
      path.style.strokeDasharray = pathLength;

      const scrollPercent =
        (window.document.body.scrollTop +
          window.document.documentElement.scrollTop) /
        (window.document.documentElement.scrollHeight -
          window.document.documentElement.clientHeight);

      const draw = pathLength * scrollPercent;
      path.style.strokeDashoffset = pathLength - draw;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          "& svg": { width: "auto", height: "auto" },
          position: "absolute",
          zIndex: 9,
          left: "50%",
          top: "114px",
        }}
      >
        <svg width="357" height="1900">
          <path
            id="svgPath"
            stroke="#f15e22"
            strokeWidth="4px"
            strokeDasharray="20, 10"
            fill="none"
            d="M268,106C293.6990093311958,156.98197064989517,319.39801866239156,207.96394129979035,282,250C244.6019813376084,292.03605870020965,144.10693468162947,325.1262054507337,89,388C33.89306531837054,450.8737945492663,24.174242611090563,543.5312368972745,18,666C11.82575738890944,788.4687631027255,9.196094874008299,940.7488469601676,13,1056C16.8039051259917,1171.2511530398324,27.04137789287624,1249.4733752620546,71,1351C114.95862210712376,1452.5266247379454,192.6383935544868,1577.3576519916141,242,1659C291.3616064455132,1740.6423480083859,312.40504788917667,1779.0960167714886,268,1879C223.59495211082336,1978.9039832285114,113.74141488880667,2140.258280922432,88,2337C62.25858511119333,2533.741719077568,120.62929255559666,2765.8708595387843,179,2998"
          />

          <path
            className="narmol"
            stroke="#fff"
            strokeWidth="6px"
            strokeDasharray="20"
            fill="none"
            d="M268,106C293.6990093311958,156.98197064989517,319.39801866239156,207.96394129979035,282,250C244.6019813376084,292.03605870020965,144.10693468162947,325.1262054507337,89,388C33.89306531837054,450.8737945492663,24.174242611090563,543.5312368972745,18,666C11.82575738890944,788.4687631027255,9.196094874008299,940.7488469601676,13,1056C16.8039051259917,1171.2511530398324,27.04137789287624,1249.4733752620546,71,1351C114.95862210712376,1452.5266247379454,192.6383935544868,1577.3576519916141,242,1659C291.3616064455132,1740.6423480083859,312.40504788917667,1779.0960167714886,268,1879C223.59495211082336,1978.9039832285114,113.74141488880667,2140.258280922432,88,2337C62.25858511119333,2533.741719077568,120.62929255559666,2765.8708595387843,179,2998"
          />
        </svg>
      </Box>

      <Box textAlign="center" my={4}>
        <Typography
          textAlign="center"
          sx={{ color: "#5f738c", fontSize: "20px" }}
          maxWidth="500px"
          lineHeight="1.8em"
          mx="auto"
        >
          {t("howWeHire.intro")}
        </Typography>
      </Box>
      <Box>
        {jobProcess.map((job, index) => (
          <Box
            key={job.key}
            display="flex"
            py={5}
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            flexDirection={index % 2 !== 0 ? "row" : "row-reverse"}
          >
            <Box maxWidth="450px">
              <Typography sx={{ fontSize: "25px", position: "relative" }}>
                <Typography
                  component="span"
                  fontWeight="bold"
                  sx={{
                    color: "#f15e22",
                    fontSize: "25px",
                    position: "absolute",
                    left: "-45px",
                  }}
                >
                  0{index + 1}
                </Typography>{" "}
                {job.title}
              </Typography>
              <Typography
                sx={{ color: "#5f738c", fontSize: "16px" }}
                lineHeight="1.8em"
                mt={2}
                maxWidth="400px"
              >
                {job.description}
              </Typography>
            </Box>
            <Box maxWidth="450px">
              <img
                src={job.img}
                alt={job.title}
                width="100%"
                style={{ zIndex: 999, position: "relative" }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Container>
  );
}

export default HowWeHire;
